import { createFileRoute } from '@tanstack/react-router'
import { AdminGuard } from '@/components/admin-guard'
import { LinearTicketsView, isLinearFilter, type LinearFilter } from '@/features/clients/LinearTicketsView'

export const Route = createFileRoute('/clients/$companyId/linear-tickets')({
  validateSearch: (search: Record<string, unknown>): { status?: LinearFilter } => (isLinearFilter(search.status) ? { status: search.status } : {}),
  component: LinearTicketsRoute,
})

function LinearTicketsRoute() {
  const { companyId } = Route.useParams()
  const { status } = Route.useSearch()
  return (
    <AdminGuard>
      <LinearTicketsView key={status ?? 'open'} companyId={companyId} initialStatus={status} />
    </AdminGuard>
  )
}
